module.exports = __webpack_public_path__ + "img/pr-11.01c6f94d.png";